import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import { apiPost } from 'app/shared-components/util/restAPI';

const emailAdapter = createEntityAdapter({
  sortComparer: (a, b) => b.receivedAt - a.receivedAt // Most recent first
});

export const {
  selectAll: selectIngestedEmails,
  selectById: selectIngestedEmailById,
} = emailAdapter.getSelectors((state) => state.emailInbox.emails);

export const getIngestedEmails = createAsyncThunk(
  "emailInbox/getIngestedEmails",
  async (startFromId, { getState }) => {
    const apiName = 'CoreAPI2';
    const path = '/x2/botuserchannel/listingestedemails';
    const options = {
      body: startFromId ? { startFromId } : {},
      headers: {},
      response: false,
    };
    const data = await apiPost(apiName, path, options);
    return data;
  }
);

const initialState = {
  emails: emailAdapter.getInitialState(),
  selectedEmail: null,
};

const emailInboxSlice = createSlice({
  name: 'emailInbox',
  initialState,
  reducers: {
    setSelectedEmail: (state, action) => {
      state.selectedEmail = action.payload;
    },
    clearSelectedEmail: (state) => {
      state.selectedEmail = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getIngestedEmails.fulfilled, (state, action) => {
      const items = action.payload;
      if (!items) return;
      emailAdapter.setAll(state.emails, items);
    });
  },
});

export const { setSelectedEmail, clearSelectedEmail } = emailInboxSlice.actions;
export const selectSelectedEmail = ({ emailInbox }) => emailInbox.selectedEmail;
export default emailInboxSlice.reducer;
